import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ErrorStateFallback } from '@/components/ui/error-state';
import { Header } from '@/components/ui/header';
import { Typography } from '@/components/ui/typography';

import { Analytics } from './analytics';
import { DashboardTable } from './dashboard-table';
import { Recommendations } from './recommendations';
import { Snapshots } from './snapshots';

export function Dashboard() {
  const intl = useIntl();

  const [showAggregateData, setShowAggregateData] = useState(true);
  const dashboardIntl = intl.formatMessage({
    defaultMessage: 'Dashboard',
    description: 'Breadcrumb/heading text for the main sourcing home view',
  });

  return (
    <main className="flex flex-1 flex-col gap-4 px-6 py-2">
      <ErrorStateFallback>
        <Header headers={[{ title: dashboardIntl }]} />
        <Snapshots />
        <Recommendations />
        <Analytics />

        {/* Divider with title */}
        <div className="flex items-center gap-4">
          <div className="bg-fx-neutral-200 h-px w-full" />
          <Typography variant="caption" className="!text-fx-neutral-400">
            <FormattedMessage
              defaultMessage="Openings"
              description="Noun: job positions or vacancies being hired for"
            />
          </Typography>
          <div className="bg-fx-neutral-200 h-px w-full" />
        </div>

        <DashboardTable
          showAggregateData={showAggregateData}
          setShowAggregateData={setShowAggregateData}
        />
      </ErrorStateFallback>
    </main>
  );
}
